/**
 * Product card "Add to bag" behaviour.
 * Extracted from snippets/card-product.liquid.
 *
 * snippets/card-product.liquid is rendered many times per page, so this file is
 * loaded once globally (see layout/theme.liquid) and registers a reusable Alpine
 * component. The variant id is passed per-card via the data-variant-id attribute.
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('cardProductAddToCart', () => ({
    loading: false,
    qty: 1,
    variantId: null,

    init() {
      const id = this.$el.dataset.variantId;
      this.variantId = id ? Number(id) : null;
    },

    addToCart() {
      if (!this.variantId) return;

      this.loading = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: this.variantId,
          quantity: this.qty,
        }),
      })
        .then((response) => response.json())
        .then(() => {
          window.Alpine.store('cartDrawerStore').reloadCartDrawer();
          window.Alpine.store('cartDrawerStore').open();
          this.loading = false;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error('Error adding to cart:', err);
          this.loading = false;
        });
    },
  }));
});
